<template>
    <b-row class="bg-light pt-3">
        <b-col class="" md="1">
            <b-form-select
                :options="limit_options"
                :value="limit"
                @input="change_rowsPerPage"
            >
            </b-form-select>
        </b-col>
        <b-col class="" md="5">
            <span class="align-middle"
                >Showing {{ offset + 1 }} - {{ offset + limit }} of
                {{ totalItems }}</span
            >
        </b-col>
        <b-col md="6">
            <b-pagination
                :per-page="limit"
                :total-rows="totalItems"
                :value="currentPage"
                @input="change_page"
                align="right"
                aria-controls="changePage"
            ></b-pagination>
        </b-col>
    </b-row>
</template>

<script>
import _ from "lodash";

export default {
    name: "OListPaging",
    props: {
        limit: { type: Number, default: 0 },
        pageOptions: {
            type: Array,
            default() {
                return [5, 10, 20, 50, 100];
            },
        },
        offset: { type: Number, default: 0 },
        totalItems: { type: Number, default: 0 },
    },
    methods: {
        change_rowsPerPage(rowsPerPage) {
            this.$emit("change-limit", rowsPerPage);
        },
        change_page(page) {
            this.$emit("change-page", page);
        },
    },
    computed: {
        limit_options() {
            return _.map(this.pageOptions || [], function (opt) {
                return { value: opt, text: opt };
            });
        },
        currentPage() {
            // NOTE The first page needs to be 1.
            return (this.offset || 0) / (this.limit || 10) + 1;
        },
    },
};
</script>

<style scoped></style>
